import { BankAccountType, EntityStatus } from '@apps/portal/src/app/core/core.module';
import { ICurrency } from '@portal/shared/helpers/src';

export interface IBankAccount {
  currency: ICurrency;
  accountHolderType: string;
  accountName?: string;
  routingTransitNumber?: string;
  sortCode?: string;
  accountNumber?: string;
  iban?: string;
  country?: string;
  countryName?: string;

  entityUid?: string;
  accountUid?: string;
  accountType?: BankAccountType;
  status?: EntityStatus;
  description?: string;
  nickname?: string;

  externalAccountReference?: string;

  formattedAccountType?: string;
}
